
import React, { useState } from 'react';
import { Calendar, BarChart2, Heart, Share2, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

interface ReleaseCardContentProps {
  id: string;
  title: string;
  releaseDate: string;
  streams: number;
  platforms?: string[];
  onShare: () => void;
}

const ReleaseCardContent: React.FC<ReleaseCardContentProps> = ({
  id,
  title,
  releaseDate,
  streams,
  platforms = ['Spotify', 'Apple Music', 'Amazon'],
  onShare
}) => {
  const [isLiked, setIsLiked] = useState(false);

  return (
    <div className="p-4">
      <div className="flex justify-between items-start mb-1">
        <div>
          <h3 className="font-bold truncate">{title}</h3>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            <Calendar className="h-3 w-3" />
            <span>{releaseDate}</span>
          </p>
        </div>
      </div>
      
      <div className="flex items-center justify-between mt-3">
        <div className="text-sm text-muted-foreground flex items-center gap-1">
          <BarChart2 className="h-3 w-3" />
          <span>{streams.toLocaleString()} streams</span>
        </div>
        
        <div className="flex gap-1">
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-8 w-8 rounded-full"
            onClick={() => setIsLiked(!isLiked)}
          >
            <Heart 
              className={cn(
                "h-4 w-4 transition-colors", 
                isLiked ? "fill-rose-500 text-rose-500" : "text-muted-foreground"
              )} 
            />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 rounded-full"
            onClick={onShare}
          >
            <Share2 className="h-4 w-4 text-muted-foreground" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="h-8 rounded-full text-xs gap-1"
            asChild
          >
            <Link to={`/releases/${id}/edit`}>
              <span>Details</span>
              <ChevronRight className="h-3 w-3" />
            </Link>
          </Button>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-1 mt-2">
        {platforms.map((platform) => (
          <Badge key={platform} variant="outline" className="text-xs">
            {platform}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default ReleaseCardContent;
